export enum BookingLoginReservationButtonStyle {
    Black = "black",
    Dark = "dark",
    Green = "green",
    Blue = "blue",
    Gray = "gray",
    Red = "red",
    Disabled = "disabled",
    DisabledBlack = "disabled_black",
}